module.exports = __webpack_public_path__ + "img/top_img05.646e2ea1.jpg";